<template>
    <component :is="currentComponent" />
</template>
<script>
import SensoLogin from '@/components/public/SensoLogin';
import PartnerLogin from '@/components/public/PartnerLogin';
import DirectLogin from '@/components/public/DirectLogin';

export default {
  name: 'Login',
  components: {
    SensoLogin,
    PartnerLogin,
    DirectLogin
  },
  data() {
    return {}
  },
  computed: {
    currentComponent() {
      if (this.$globalConfig.APP_NAME === 'senso') return 'SensoLogin';
      if (this.$globalConfig.APP_NAME === 'partner') return 'PartnerLogin';
      if (this.$globalConfig.APP_NAME === 'direct') return 'DirectLogin';
      return null;
    },
  },
};
</script>